exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".element-wrapper {\n  position: absolute;\n  padding: 1px;\n  cursor: move; }\n  .element-wrapper.selected {\n    border: 1px dashed gray; }\n  .element-wrapper .remove-btn {\n    display: flex;\n    position: absolute;\n    top: -9px;\n    right: -4px;\n    border-radius: 50%;\n    color: white;\n    background-color: #727272;\n    cursor: pointer;\n    width: 15px;\n    height: 15px;\n    align-items: center;\n    justify-content: center; }\n  .element-wrapper .resize {\n    background-color: #727272;\n    width: 10px;\n    height: 10px;\n    cursor: se-resize;\n    position: absolute;\n    right: 0px;\n    bottom: 0px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Element/Element.scss
// module id = 540
// module chunks = 0